module.exports = __webpack_public_path__ + "static/media/search-solid.53ddb591.svg";